<script lang="ts">
  /** Indeterminate progress bar pinned to the top of the viewport. Shown
   *  whenever the route changes (lazy-load of the route Component takes
   *  a moment) or any consumer toggles `progressBus.busy`. */
  import { progress } from '$domain/progress.svelte';

  let visible = $derived(progress.busy);
</script>

{#if visible}
  <div class="page-progress" role="progressbar" aria-label="loading">
    <div class="bar"></div>
  </div>
{/if}

<style>
  .page-progress {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 2px;
    overflow: hidden;
    z-index: var(--z-toast);
    pointer-events: none;
    background: transparent;
  }
  .bar {
    position: absolute;
    inset: 0;
    background: linear-gradient(90deg, transparent, var(--accent), transparent);
    animation: slide 1.1s ease-in-out infinite;
    transform: translateX(-100%);
  }
  @keyframes slide {
    50% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(100%);
    }
  }
  @media (prefers-reduced-motion: reduce) {
    .bar {
      animation: none;
      background: var(--accent);
      transform: none;
    }
  }
</style>
